var React = require('react');

function ChevronRight (props) {
    return React.createElement("svg",props,React.createElement("path",{"fillRule":"evenodd","clipRule":"evenodd","d":"M8.29289 5.29387C8.68342 4.90335 9.31643 4.90335 9.70696 5.29387L15.707 11.2939C16.0975 11.6844 16.0975 12.3174 15.707 12.7079L9.70696 18.7079C9.31643 19.0985 8.68342 19.0985 8.29289 18.7079C7.90237 18.3174 7.90237 17.6844 8.29289 17.2939L13.5859 12.0009L8.29289 6.70793C7.90237 6.31741 7.90237 5.68439 8.29289 5.29387Z"}));
}

ChevronRight.defaultProps = {"width":"24","height":"24","viewBox":"0 0 24 24"};

module.exports = ChevronRight;

ChevronRight.default = ChevronRight;
